// Dependency Analyzer API — exhaustive inbound/outbound reference finder.
// body: { scope:'schema'|'server', database, kind, name, direction:'inbound'|'outbound'|'both' }
// → { inbound:[dep], outbound:[dep], scanned:{databases,objects}, skipped, elapsedMs }
import { api } from './api.js';

export async function analyzeDependencies(connId, body) {
  return api.post(`/api/connections/${connId}/dependencies`, body);
}
